import axios from 'axios'
import { Loading, Message } from 'element-ui'

// const collectorUrl = '127.0.0.1:8918'
const collectorUrl = '127.0.0.1'

let loadinginstace = null

export default function () {
  axios.defaults.timeout = 30000

  axios.interceptors.request.use((config) => {
    loadinginstace = Loading.service({ lock: true })

    if (config.url.indexOf(collectorUrl) === -1) {
      config.headers = {
        'X-User-Agent': 'web',
        'X-Company': '00'
      }

      config.withCredentials = true
    }
    return config
  }, (err) => {
    loadinginstace.close()

    Message.error({
      message: err
    })
    return Promise.reject(err)
  })

  axios.interceptors.response.use((response) => {
    loadinginstace.close()

    if (response.config.url.indexOf(collectorUrl) === -1) {
      if (response.data.code === 10003) {
        location.href = '/'
      } else if (response.data.code === 8010) {
        Message.error({
          message: response.data.message
        })
        location.href = '/'
      } else if (response.data.code !== 0) {
        Message.error({
          message: response.data.message
        })
      }
    }
    return response.data
  }, (error) => {
    loadinginstace.close()
    Message.error({
      message: '服务器连接失败！'
    })
    return Promise.reject(error)
  })
}



// WEBPACK FOOTER //
// ./src/common/ajax/interceptors.js